import { render, staticRenderFns } from "./productShare.vue?vue&type=template&id=dac6a09c&scoped=true&"
import script from "./productShare.vue?vue&type=script&lang=js&"
export * from "./productShare.vue?vue&type=script&lang=js&"
import style0 from "./productShare.vue?vue&type=style&index=0&id=dac6a09c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac6a09c",
  null
  
)

export default component.exports